import { render, staticRenderFns } from "./IncRnaGseaAnalysis.vue?vue&type=template&id=1a40b944&scoped=true"
import script from "./IncRnaGseaAnalysis.vue?vue&type=script&lang=js"
export * from "./IncRnaGseaAnalysis.vue?vue&type=script&lang=js"
import style0 from "./IncRnaGseaAnalysis.vue?vue&type=style&index=0&id=1a40b944&prod&scoped=true&lang=css"
import style1 from "./IncRnaGseaAnalysis.vue?vue&type=style&index=1&id=1a40b944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40b944",
  null
  
)

export default component.exports